import { c as _c } from "react/compiler-runtime";
import { postEntitiesByFpIdDecryptAmlHitsBySignalIdMutation } from '@onefootprint/fetch-dashboard';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import useEntityId from '@/entity/hooks/use-entity-id';
import useSession from '@/hooks/use-session';
const useRiskSignalAmlHits = () => {
  const $ = _c(8);
  const {
    authHeaders
  } = useSession();
  const entityId = useEntityId();
  const queryClient = useQueryClient();
  const t0 = authHeaders["x-fp-dashboard-authorization"];
  let t1;
  if ($[0] !== t0) {
    t1 = postEntitiesByFpIdDecryptAmlHitsBySignalIdMutation({
      headers: {
        "X-Fp-Dashboard-Authorization": t0
      }
    });
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== entityId || $[3] !== queryClient) {
    t2 = (response, options) => {
      const riskSignalId = options.path.signalId;
      queryClient.setQueryData(["entity", entityId, "risk-signals", riskSignalId, "aml-hits"], response);
    };
    $[2] = entityId;
    $[3] = queryClient;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = {
      ...t1,
      onSuccess: t2
    };
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const mutation = useMutation(t3);
  return mutation;
};
export default useRiskSignalAmlHits;